<template>
  <div id="menue">
    <nav>
      <div class="nav-wrapper blue accent-1">
        <a href="/" class="brand-logo" alt='Logo'> &nbsp; <span style="color:orange;">&lt;</span><span style="font-size:26px" >Hi </span> <span style="color:#FFF;font-size:24px;">/</span><span style="color:orange;">&gt;</span></a>
        <a href="#" data-target="mobile-demo" class="sidenav-trigger"><i class="material-icons">menu</i></a>
        <ul class="right hide-on-med-and-down">
          <li><a href="/">Home</a></li>
          <li><router-link to="/showp" exact>Research</router-link></li>
          <li><router-link to="/projects" exact>Projects</router-link></li>
          <li><router-link to="/hobies" exact>Hobies</router-link></li>
          <li><router-link to="/students" exact>Students</router-link></li>
          <li><a href="#">Demo Apps</a></li>
          <li v-if="!formControl"><a href="#modal2" class="modal-trigger">Profile</a></li>
          <li v-if="formControl"><a href="#modal3" class="modal-trigger">Register</a></li>
          <li v-if="formControl"><a href="#modal1" class="modal-trigger">Sign in</a></li>
          <li v-if="!formControl"><a href="#" class="" v-on:click="logout">Log out</a></li>
        </ul>
      </div>
    </nav>

    <ul class="sidenav" id="mobile-demo">
      <li><a href="/">Home</a></li>
      <li><router-link to="/showp" exact>Research</router-link></li>
      <li><router-link to="/projects" exact>Projects</router-link></li>
      <li><router-link to="/hobies" exact>Hobies</router-link></li>
      <li><router-link to="/students" exact>Students</router-link></li>
      <li><a href="#">Demo Apps</a></li>
      <li v-if="!formControl"><a href="#modal2" class="modal-trigger">Profile</a></li>
      <li v-if="formControl"><a href="#modal3" class="modal-trigger">Register</a></li>
      <li v-if="formControl"><a href="#modal1" class="modal-trigger">Sign in</a></li>
      <li v-if="!formControl"><a href="#" class="" v-on:click="logout">Log out</a></li>
    </ul>
    <div>

      <!-- Modal Signin -->
      <div id="modal1" class="modal">
        <div class="modal-content">
          <h5>Sign in</h5>
           <div class="row">
            <div class="input-field col s12">
                <label class="alert-info" id="MsgFromSrv"></label>
            </div>
           </div>
            <div class="row">
              <div class="input-field col s12">
                <input id="email" type="email" class="validate">
                <label for="email">Email</label>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12">
                <input id="password" type="password" class="validate">
                <label for="password">Password</label>
              </div>
            </div>
          <button id="loginBtn" v-on:click="iamCalled" class="waves-effect orange waves-light btn-small">Login</button>
        </div>
      </div>

      <!-- Modal Profile -->
      <div id="modal2" class="modal">
        <div class="modal-content">
          <h5>Hi, {{profile.split("@",1)[0]}}</h5>
           <div class="row">
            <div class="input-field col s12">
                <label>You have been signed in with {{profile}} address.</label>
            </div>
           </div>
        </div>
      </div>
      <!-- Modal Sing Up -->
      <div id="modal3" class="modal">
        <div class="modal-content">
          <h5>Hi, {{profile.split("@",1)[0]}}</h5>
           <div class="row">
            <div class="input-field col s12">
                <label>{{profile}}</label>
            </div>
           </div>
        </div>
      </div>
 
    </div>
         <!-- Load Facebook SDK for JavaScript -->
      <div id="fb-root"></div>
     

      <!-- Your Chat Plugin code -->
      <div class="fb-customerchat"
        attribution=setup_tool
        page_id="1787439241487733"
  theme_color="#ff7e29">
      </div>

      <!-- Facebook M -->
  </div> <!--End of Menue-->
</template>
<script>
import { constants } from 'crypto';
export default {
  name: 'Menue',
  props:{
    profile:{
      type:String
    }
  },
  data(){
    return {
      formControl: false
    }
  },
  methods:{
    iamCalled(){
     const email = document.getElementById('email').value;
     const password = document.getElementById('password').value;
     const elem = document.getElementById('MsgFromSrv');
      this.$emit("iamCalled",[email,password,elem]);
    },
    logout(){
      this.formControl=true;
      firebase.auth().signOut().then(function() {
        }, function(error) {
        console.log(error);
      });
    }
  },
  created(){
    firebase.auth().onAuthStateChanged(user=> {
    if(user)
      this.formControl=false;
    else
      this.formControl=true; 
    });
    
  }
}
</script>
<style scoped>
.router-link-active{
  background:#aed581;
}
#menue,nav{
  font-size: 1px;
  padding: 0%;
  margin: 0%;
}
</style>